<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" :back-level="1000" />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="(item,index) in list" :key="index" class="rect">
        <van-row>
          <van-col span="16" class="title" :style="'color:'+GetDiveMainBack()">{{ item.examName }}</van-col>
          <van-col span="8" class="rigth titleDate">{{ formatDate(item.beginTime,'yyyy/MM/dd hh:mm',true) }}</van-col>
        </van-row>
        <template v-if="!item.finishTime">
          <div class="score">
            <van-count-down
              class="scoreMain"
              :time="item.examFinishTime"
              :format="item.examFinishTime>3600000?'HH时mm分ss秒':'mm分ss秒'"
              @finish="onCountFinish"
            />
            <div class="scoreAbout">剩余时间</div>
          </div>
          <van-button type="primary" :color="GetDiveMainBack()" size="small" class="buttonDown" @click="onExam(item)">继续测验</van-button>
        </template>
        <template v-if="item.finishTime && item.isPass">
          <div class="score" :style="'background-color:'+GetDiveMainBack()">
            <div class="scoreMain" style="color:#fff">{{ item.myScore*100/item.totalScore }}<span>分</span></div>
            <div class="scoreAbout" style="color:#fff">通过测试</div>
          </div>
          <van-row v-if="item.finishTime" gutter="10">
            <van-col span="12"><van-button type="primary" color="#BFBFBF" size="small" class="buttonDown" @click="onErrorList(item.examResultId)">错题回顾</van-button></van-col>
            <van-col span="12"><van-button type="primary" color="#BFBFBF" size="small" class="buttonDown" @click="onExamPrint(item.examResultId)">导出答题卡</van-button></van-col>
          </van-row>
        </template>
        <template v-if="item.finishTime && !item.isPass">
          <div class="score">
            <div class="scoreMain">{{ item.myScore*100/item.totalScore }}<span>分</span></div>
            <div class="scoreAbout">未通过测试</div>
          </div>
          <van-row v-if="item.finishTime" gutter="10">
            <van-col span="12"><van-button type="primary" size="small" color="#000" class="buttonDown" @click="onErrorList(item.examResultId)">错题回顾</van-button></van-col>
            <van-col span="12"><van-button type="primary" size="small" color="#000" class="buttonDown" @click="onExamPrint(item.examResultId)">导出答题卡</van-button></van-col>
          </van-row>
        </template>

      </div>
    </van-list>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, List, CountDown } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [List.name]: List,
    [CountDown.name]: CountDown,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '我的测验',
      backurl: '/my/index',
      loading: undefined,
      finished: false,
      list: [],
      search: {
        limit: 30,
        page: 1
      }
    }
  },

  created() {
    this.titleTop = GetSysTitle()
  },
  methods: {
    ShowMoney,
    GetDiveMainBack,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLoad() {
      if (this.loading === undefined) {
        this.loading = true
        return
      }
      this.loading = true
      request({
        url: '/DiveLearn/getUserExamResultList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    onCountFinish() {
      this.init()
    },
    onExam(item) {
      if (item.finishTime !== null) {
        return
      }
      if (item.hashCode === null) {
        return
      }
      this.$router.push('/divetrip/exam?hashCode=' + item.hashCode)
    },
    onErrorList(id) {
      this.$router.push('/divetrip/examErrorList/' + id)
    },
    onExamPrint(id) {
      this.$router.push('/divetrip/examPrint/' + id)
    }
  }
}
</script>
<style scoped>
.rect{
  padding: 0.8em 1em;
  background-color: #fff;
  margin-bottom: 0.5em;

}
.rect .title
{
  font-weight: 700;
  font-size: 0.8em;
}
.rect .titleDate{
  font-size: 0.8em;
  color: #999;
}

.rect .score{
  border-radius: 0.5em;
  background-color: #F3F3F3;
  text-align: center;
  padding: 0.5em 0;
  margin: 1em 0;
}
.rect .score .scoreMain{
  font-size: 2em;
  padding-top: 0.5em;
  padding-bottom: 0.2em;
  font-weight: 700;
  color: #000;
}
.rect .score .scoreMain span{
  font-size: 0.3em;
}
.rect .score .scoreAbout{
  color: #999;
  font-size: 0.7em;
}
.rect .buttonDown{
  width: 100%;
  border-radius: 10em;
  height: 2em;
  line-height: 2em;
}
</style>
